import React from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export const DashboardLayout = ({ children, title }) => {
    return (
        <div className="min-h-screen bg-slate-50 flex">
            <Sidebar />

            <div className="flex-1 lg:ml-64 flex flex-col min-h-screen">
                <Topbar title={title} />

                <main className="flex-1 p-4 lg:p-8 overflow-x-hidden mt-16 lg:mt-0">
                    {children}
                </main>
            </div>
        </div>
    );
};
